<template>
  <div class="content">
    <div class="header">
      <v-layout row wrap align-center class="hero" :style="header()">
        <v-container fluid>
          <v-row>
            <v-col>
              <h2 class="display-2 text-center white--text pb-12">
                Opening Our Minds to Our Brains’ Potential
              </h2>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
    </div>

    <v-container>
      <v-row>
        <v-col xl="6" lg="6" md="6" sm="12" xs="12">
          <Title title="New Release" subtitle="buy now" />
          <p class="pb-6">
            In her debut book, Angela Sette reveals the limitless possibilities
            that can be acquired when we learn to harness our own brainpower.
            Through her own stories of the struggles and successes of raising
            children, she leaves the reader with an overwhelming feeling of
            soulfulness, while merging the lessons that were learned about the
            brain and our energy along the way.
          </p>
          <p class="grey--text">Select Format</p>
          <v-row>
            <v-col cols="12" class="py-2">
              <v-btn-toggle
                v-model="option"
                borderless
                color="deep-purple accent-3"
              >
                <v-btn value="soft" large>
                  <span class="text-left">
                    Soft Cover<br />
                    <span :class="option === 'soft' ? 'font-weight-bold' : ''"
                      >$11.99</span
                    >
                  </span>
                </v-btn>

                <v-btn value="hard" large>
                  <span class="text-left">
                    Hard Cover<br />
                    <span :class="option === 'hard' ? 'font-weight-bold' : ''"
                      >$19.99</span
                    >
                  </span>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <p class="grey--text mb-1 mt-3">{{ options[option].type }}</p>
              <h1 class="font-weight-bold">{{ options[option].price }}</h1>
              <div
                :style="
                  `${
                    option != 'soft'
                      ? 'visibility:hidden; position:absolute; top:-66px;'
                      : ''
                  }`
                "
                id="product-component-1617825902212"
                class="mt-n3"
              ></div>
              <div
                :style="
                  `${
                    option != 'hard'
                      ? 'visibility:hidden; position:absolute; top:-66px;'
                      : ''
                  }`
                "
                id="product-component-1617826100864"
                class="mt-n3"
              ></div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels v-model="moreBuyingOptions">
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >More Buying Options</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-btn
                      raised
                      class="white--text mr-1"
                      color="black"
                      target="_blank"
                      href="https://www.amazon.com/Opening-Our-Minds-Brains-Potential/dp/1982230495/"
                    >
                      Buy on Amazon
                    </v-btn>
                    <v-btn
                      raised
                      class="mx-1"
                      target="_blank"
                      href="https://www.balboapress.com/en/bookstore/bookdetails/784000-opening-our-minds-to-our-brains-potential"
                    >
                      Buy from Publisher
                    </v-btn>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-col>
        <v-col xl="6" lg="6" md="6" sm="12" xs="12" class="image pt-12">
          <v-img src="@/assets/book.jpg" class="image" width="100%"></v-img>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <Title title="The Book" subtitle="more about" />
      <v-row>
        <v-col cols="12">
          <p class="pb-6">
            Throughout the book, Angela Sette explores how we are all
            artistically woven intricately into the unique beings that we are
            today by the people in our lives, life experiences and knowledge we
            attain and uncovers the ways in which this knowledge is unexpectedly
            learned not just from our own struggles and our elders’ but from our
            youngest teachers, our children. Intermingled amongst stories are
            methods that will chip away fear along with self limiting beliefs.
            Readers will find themselves reconnected with their passions,
            desires and role as evolutionary beings with the ability to open
            their minds to their own human potential.
          </p>
        </v-col>
      </v-row>
    </v-container>

    <!-- FIXME: Modify this code so that the columns change on resizong. There was a bug prior so I used 2 spereate declarations and hid them on differnet sizes.  -->
    <v-container class="pb-12">
      <v-row>
        <v-col cols="6" class="hidden-sm-and-down">
          <Title title="Angela Sette" subtitle="author" />

          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges.
          </p>
          <v-btn raised class="white--text" color="#b697ff" href="/about">
            READ MORE
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="hidden-sm-and-down">
          <GeoImage />
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <Title title="Angela Sette" subtitle="about" />
          <p class="pb-6">
            Angela Sette is a writer that taps into human potential stemming
            from our minds as well as our bodies. She is health Science
            educated, along with extensive experience as a mind-body movement
            specialist in Yoga, Pilates, Meditation and Dance. Angela had the
            privilege of working with high achievers, as well as those faced
            with physical and mental challenges.
          </p>
          <v-btn raised class="white--text" color="#b697ff" href="/about">
            READ MORE
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up">
          <GeoImage />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Title from "../components/Title";
import GeoImage from "../components/GeoImage";

export default {
  components: {
    Title,
    GeoImage
  },
  data() {
    return {
      background: require("@/assets/background.jpg"),
      option: "soft",
      options: {
        soft: {
          type: "Soft Cover",
          price: "$11.99",
          variantId: "39569536385192"
        },
        hard: {
          type: "Hard Cover",
          price: "$19.99",
          variantId: "39569536417960"
        }
      },
      moreBuyingOptions: false
    };
  },
  methods: {
    header() {
      return {
        backgroundImage: `url(${this.background})`
      };
    }
  },
  created() {
    var scriptURL =
      "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
    if (window.ShopifyBuy) {
      if (window.ShopifyBuy.UI) {
        ShopifyBuyInit();
      } else {
        loadScript();
      }
    } else {
      loadScript();
    }
    function loadScript() {
      var script = document.createElement("script");
      script.async = true;
      script.src = scriptURL;
      (
        document.getElementsByTagName("head")[0] ||
        document.getElementsByTagName("body")[0]
      ).appendChild(script);
      script.onload = ShopifyBuyInit;
    }
    function ShopifyBuyInit() {
      var client = window.ShopifyBuy.buildClient({
        domain: "angela-sette.myshopify.com",
        storefrontAccessToken: "16cb704ab6df88c23cbd54d350f8c27b"
      });
      window.ShopifyBuy.UI.onReady(client).then(function(ui) {
        ui.createComponent("product", {
          id: "6627733143720",
          variantId: "39569536385192",
          node: document.getElementById("product-component-1617825902212"),
          moneyFormat: "%24%7B%7Bamount%7D%7D",
          options: {
            product: {
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "calc(25% - 20px)",
                    "margin-left": "20px",
                    "margin-bottom": "50px"
                  },
                  "text-align": "left"
                },
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px",
                  "padding-left": "20px",
                  "padding-right": "20px"
                },
                quantityInput: {
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px"
                }
              },
              buttonDestination: "checkout",
              contents: {
                img: false,
                title: false,
                price: false,
                options: false
              },
              text: {
                button: "BUY NOW"
              },
              googleFonts: ["Roboto"],
              variantId: "39569536385192"
            },
            productSet: {
              styles: {
                products: {
                  "@media (min-width: 601px)": {
                    "margin-left": "-20px"
                  }
                }
              }
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true
              },
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                  }
                },
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px",
                  "padding-left": "20px",
                  "padding-right": "20px"
                },
                quantityInput: {
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px"
                }
              },
              googleFonts: ["Roboto"],
              text: {
                button: "Add to cart"
              }
            },
            option: {},
            cart: {
              styles: {
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px"
                }
              },
              text: {
                total: "Subtotal",
                button: "Checkout"
              },
              popup: false,
              googleFonts: ["Roboto"]
            },
            toggle: {
              styles: {
                toggle: {
                  "font-family": "Roboto, sans-serif",
                  "background-color": "#b697ff",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  ":focus": {
                    "background-color": "#a488e6"
                  }
                },
                count: {
                  "font-size": "14px"
                }
              },
              googleFonts: ["Roboto"]
            }
          }
        });
      });
      window.ShopifyBuy.UI.onReady(client).then(function(ui) {
        ui.createComponent("product", {
          id: "6627733143720",
          variantId: "39569536417960",
          node: document.getElementById("product-component-1617826100864"),
          moneyFormat: "%24%7B%7Bamount%7D%7D",
          options: {
            product: {
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "calc(25% - 20px)",
                    "margin-left": "20px",
                    "margin-bottom": "50px"
                  },
                  "text-align": "left"
                },
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px",
                  "padding-left": "20px",
                  "padding-right": "20px"
                },
                quantityInput: {
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px"
                }
              },
              buttonDestination: "checkout",
              contents: {
                img: false,
                title: false,
                price: false,
                options: false
              },
              text: {
                button: "BUY NOW"
              },
              googleFonts: ["Roboto"],
              variantId: "39569536417960"
            },
            productSet: {
              styles: {
                products: {
                  "@media (min-width: 601px)": {
                    "margin-left": "-20px"
                  }
                }
              }
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true
              },
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                  }
                },
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px",
                  "padding-left": "20px",
                  "padding-right": "20px"
                },
                quantityInput: {
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px"
                }
              },
              googleFonts: ["Roboto"],
              text: {
                button: "Add to cart"
              }
            },
            option: {},
            cart: {
              styles: {
                button: {
                  "font-family": "Roboto, sans-serif",
                  "font-size": "14px",
                  "padding-top": "15px",
                  "padding-bottom": "15px",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  "background-color": "#b697ff",
                  ":focus": {
                    "background-color": "#a488e6"
                  },
                  "border-radius": "4px"
                }
              },
              text: {
                total: "Subtotal",
                button: "Checkout"
              },
              popup: false,
              googleFonts: ["Roboto"]
            },
            toggle: {
              styles: {
                toggle: {
                  "font-family": "Roboto, sans-serif",
                  "background-color": "#b697ff",
                  ":hover": {
                    "background-color": "#a488e6"
                  },
                  ":focus": {
                    "background-color": "#a488e6"
                  }
                },
                count: {
                  "font-size": "14px"
                }
              },
              googleFonts: ["Roboto"]
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-color: #fff;

  .header {
    height: 50vh;
  }
  .hero {
    height: 100%;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .image {
    margin: auto;
  }
}
</style>
